import { inject, Injectable } from '@angular/core';
import { DocumentViewerService, MediaViewerService, PdfViewerService, showDocumentParameters } from '@pxl/models/contracts';
import { DocumentModel, DocumentType } from '@pxl/shared/generated';

@Injectable()
export class DefaultDocumentViewerService implements DocumentViewerService {
    private readonly pdfViewerService = inject(PdfViewerService);
    private readonly mediaViewerService = inject(MediaViewerService);

    public show(parameters: showDocumentParameters): void {
        const isPdf = parameters.document.documentType === DocumentType.Pdf;

        if (isPdf) {
            const filename = (parameters.filename ?? parameters.title) + '.pdf';
            this.pdfViewerService.showPdf(parameters.document, parameters.title, filename);
        } else {
            let documents: DocumentModel[] = [];
            if (parameters.allDocuments) {
                // Make sure that documents contain only easy image viewer documents, not PDF documents.
                documents = parameters.allDocuments.filter((document) => document.documentType !== DocumentType.Pdf);
            } else {
                documents.push(parameters.document);
            }

            if (parameters.document.documentType === DocumentType.EasyImageViewer) {
                this.mediaViewerService.showMedia(parameters.title, documents, parameters.document.id);
            } else {
                this.mediaViewerService.showMediaInLightbox(documents, 0);
            }
        }
    }
}
